import axios from 'axios';
import { commonConfiguration } from 'io/API';
import { onRequestError } from 'io/API/errorHandling';
import { getCookie, setCookie } from 'utils/cookies';

const getUserFromCredentials = async (username, password, contextConfiguration) => {
	let token = getCookie('authToken');
	let response;

	if (!token) {
		try {
			response = await axios.post(
				'/api/token-auth/',
				{ username, password },
				{
					...commonConfiguration,
					...contextConfiguration,
					headers: {
						'Content-Type': 'application/json',
						'X-Requested-With': 'XMLHttpRequest',
					},
				}
			);

			if (response.data && response.data.token) {
				token = response.data.token;
				setCookie('authToken', token);
			}
		} catch (error) {
			if (error.response && error.response.status === 400) 
				throw error;
			
			throw error;
		}
	}

	if (token) {
		const userResponse = await axios.get('/user', {
			...commonConfiguration,
			...contextConfiguration,
			headers: {
				Authorization: `Token ${token}`,
				'X-Requested-With': 'XMLHttpRequest',
			},
		});

		return userResponse;
	}

	return response;
};

export default getUserFromCredentials;
